
import { showFailed } from "../../Customs/SweetAlerts";
import axiosInstance from "../../Middleware/AxiosInstanceInterceptor";

const baseURL = process.env.REACT_APP_API_BASE_URL;
console.log("base url",baseURL);



export const cmsLogin = async (formData) => {
  const updatedData = { email: formData.email };
  try {
    console.log("Base URL:", baseURL);
    const response = await axiosInstance.post(`${baseURL}/auth/login`, updatedData);
    console.log(response,"response")
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error?.[0] ||
      error.response?.data?.message ||
      error.message ||
      "Something went wrong";

    showFailed("Failed...", errorMessage);
    console.error("Login error:", error);
    throw new Error(errorMessage);
  }
};

export const cmsLoginVerify = async (formData, otp) => {
  const updatedData = {
    email: formData.email,
    code: otp,
  };
  try {
    console.log("check base url",baseURL)
    const response = await axiosInstance.post(`${baseURL}/auth/verify`, updatedData);
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error?.[0] ||
      error.response?.data?.message ||
      error.message ||
      "Something went wrong";
    showFailed("Failed...", errorMessage);
    console.error("Verify error:", error);
    throw new Error(errorMessage);
  }
};
